import { Container } from '../../common/container/Container'

export type FomrContainerConfig = {
    moduleFullUrl: string
}

export type FomrProps = {
    parentContainer: Container
    config: FomrContainerConfig
}

export const FORM_API_KEY = Symbol('FORM_API_KEY')
export const FORM_SERVICE_KEY = Symbol('FORM_SERVICE_KEY')
export const FORMS_MODULE = Symbol('FORMS_MODULE')
